/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
export enum MediaType {
  AUDIO = "audio",
  VIDEO = "video",
  SCREEN = "screen",
}
